import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "post-care-box border-0" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("section", { class: "p-5 d-flex flex-column text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }),
  /*#__PURE__*/_createElementVNode("span", { class: "mt-1 big-text" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Loading...")
  ])
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "post-care-head text-center fw-bold p-2 text-white border-0" }, "AxxessCare", -1 /* HOISTED */)
const _hoisted_6 = { class: "d-flex justify-content-between px-3 py-2" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = { class: "row px-3 py-2" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "visit-task",
  class: "fw-bold pb-2"
}, [
  /*#__PURE__*/_createTextVNode("Visit Task"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: null }, "-- Select Task --", -1 /* HOISTED */)
const _hoisted_13 = ["value"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "text-danger" }, "Sorry, No Matching task found ", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  "with.bind": "postToAxxessCareDetails",
  class: "col d-flex justify-content-between"
}
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Address")
const _hoisted_20 = { class: "" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "me-3" }
const _hoisted_25 = { class: "fw-bold" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Pay Rate")
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "row px-3 py-2" }
const _hoisted_29 = { class: "form-group col" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "visit-details",
  class: "fw-bold"
}, "Visit Details", -1 /* HOISTED */)
const _hoisted_31 = { class: "form-group form-check mb-0 mt-3" }
const _hoisted_32 = ["checked"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label internal-visit fw-bold",
  for: "privatePostCheckBoxNew"
}, "Post visit internally. (Only your staff will be able to apply.)", -1 /* HOISTED */)
const _hoisted_34 = { class: "form-group col" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  for: "hipaa-info",
  class: "fw-bold"
}, "HIPAA Protected Information", -1 /* HOISTED */)
const _hoisted_36 = { class: "d-block justify-content-right p-3 text-end post-to-axxessCare" }
const _hoisted_37 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.options.TaskName), 1 /* TEXT */),
              _createElementVNode("h6", _hoisted_8, _toDisplayString(_ctx.formatDate(_ctx.options.StartDate)), 1 /* TEXT */)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  (_ctx.axxessCareSpecialities.length)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postToAxxessCareDetails.SpecialtyId) = $event))
                      }, [
                        _hoisted_12,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.axxessCareSpecialities, (specialty) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: specialty.id,
                            key: specialty.id
                          }, _toDisplayString(specialty.name), 9 /* TEXT, PROPS */, _hoisted_13))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */)), [
                        [_vModelSelect, _ctx.postToAxxessCareDetails.SpecialtyId]
                      ])
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("i", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editAddress())),
                        class: "cursor-pointer fas fa-edit ms-2 edit-icon"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      (_ctx.postToAxxessCareDetails.AddressLine1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.postToAxxessCareDetails.AddressLine1), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (_ctx.postToAxxessCareDetails.AddressLine2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.postToAxxessCareDetails.AddressLine2), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (
                                            _ctx.postToAxxessCareDetails.City ||
                                            _ctx.postToAxxessCareDetails.StateCode ||
                                            _ctx.postToAxxessCareDetails.ZipCode
                                        )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.postToAxxessCareDetails.City) + " " + _toDisplayString(_ctx.postToAxxessCareDetails.StateCode) + " " + _toDisplayString(_ctx.postToAxxessCareDetails.ZipCode), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("i", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editPayRate())),
                        class: "cursor-pointer fas fa-edit ms-2 edit-icon"
                      })
                    ]),
                    (_ctx.postToAxxessCareDetails.PayRates && _ctx.postToAxxessCareDetails.PayRates.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postToAxxessCareDetails.PayRates, (rate) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: rate.Label
                            }, _toDisplayString(rate.Label) + ": $" + _toDisplayString(rate.Rate), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control form-control-sm",
                    name: "visit-details",
                    id: "visit-details",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.postToAxxessCareDetails.VisitDetails) = $event)),
                    rows: "5",
                    placeholder: "Visible to all applicants. Please limit to non-HIPAA info."
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.postToAxxessCareDetails.VisitDetails]
                  ]),
                  _createElementVNode("span", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      checked: _ctx.postToAxxessCareDetails.PrivateJob,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.postToAxxessCareDetails.PrivateJob) = $event)),
                      type: "checkbox",
                      class: "form-check-input",
                      id: "privatePostCheckBoxNew"
                    }, null, 8 /* PROPS */, _hoisted_32), [
                      [_vModelCheckbox, _ctx.postToAxxessCareDetails.PrivateJob]
                    ]),
                    _hoisted_33
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control form-control-sm",
                    name: "hipaa-info",
                    id: "hipaa-info",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.postToAxxessCareDetails.HipaaInfo) = $event)),
                    rows: "5",
                    placeholder: "Visible to only the assigned clinician."
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.postToAxxessCareDetails.HipaaInfo]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("button", {
              disabled: _ctx.postToAxxessCareDetails.SpecialtyId == 0,
              class: "axxesscare-confirm btn me-2 text-white border-0",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.postToAxxessCare()))
            }, " Confirm Posting ", 8 /* PROPS */, _hoisted_37),
            _createElementVNode("button", {
              class: "btn",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancel()))
            }, "Cancel")
          ])
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}